import Vue from 'vue'
import store from '@/store/index.js'
import App from '@/App.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import router from '@/router/index.js'
import Navigation from 'vue-navigation'

Vue.use(Navigation, {router, store, moduleName: 'navigation', keyName: 't'});

Vue.use(ElementUI);

import Utils from '@/utils/index.js'

Vue.prototype.utils = Utils;
Vue.config.productionTip = false;


const main = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});


export default main;



// WEBPACK FOOTER //
// ./src/main.js